import template from "./kiosk_login.html";
import en from "./en.json";
import es from "./es.json";
import logoUrl from "../../../../../assets/harvust-logo-008.svg";
import { homescreenState, kioskPairState } from "../../../../base.routes";
import { FACING_MODE_USER } from "../../../common/common.constants";
import mixpanel from "mixpanel-browser";

class KioskLoginController {
    /* @ngInject */
    constructor(KioskService, AuthService, $state, $window) {
        this.KioskService = KioskService;
        this.AuthService = AuthService;
        this.$state = $state;
        this.$window = $window;
        this.logoUrl = logoUrl;
        this.facingMode = FACING_MODE_USER;
    }

    $onInit() {
        let ctrl = this;
        ctrl.KioskService.stopInactivityLogout();
        ctrl.AuthService.clearStorage();
        return ctrl.loadPairedDevice();
    }

    loadPairedDevice() {
        let ctrl = this;
        ctrl.loading = true;
        ctrl.error = undefined;
        return ctrl.KioskService.pairedDevice(ctrl.kioskId)
            .then(function (kiosk) {
                if (!ctrl.destroyed) {
                    ctrl.kiosk = kiosk;
                    ctrl.KioskService.rememberKiosk(kiosk);
                }
            })
            .catch(function (response) {
                if (ctrl.destroyed) {
                    return;
                }
                if (response.status === 401 || response.status === 403) {
                    ctrl.pairDevice();
                } else {
                    ctrl.error = "kioskLogin.PAIRED_DEVICE_ERROR";
                }
            })
            .finally(function () {
                if (!ctrl.destroyed) {
                    ctrl.loading = false;
                }
            });
    }

    startScanning() {
        let ctrl = this;
        if (ctrl.kiosk && !ctrl.processing && !ctrl.destroyed) {
            ctrl.error = undefined;
            ctrl.scanning = true;
        }
    }

    cancelScanning() {
        let ctrl = this;
        ctrl.scanning = false;
    }

    cameraError() {
        let ctrl = this;
        if (!ctrl.destroyed) {
            ctrl.scanning = false;
            ctrl.error = "kioskLogin.CAMERA_ERROR";
        }
    }

    scan(value) {
        let ctrl = this;
        if (!ctrl.scanning || ctrl.processing || ctrl.destroyed) {
            return;
        }
        ctrl.scanning = false;
        ctrl.processing = true;
        return ctrl.KioskService.scan(ctrl.kioskId, value)
            .then(function (tokens) {
                if (!ctrl.destroyed) {
                    mixpanel.track("Scanned kiosk badge", {
                        company_sid: ctrl.kiosk.grower_organization,
                        kiosk_sid: ctrl.kioskId,
                    });
                    ctrl.KioskService.rememberKiosk({ sid: ctrl.kioskId });
                    ctrl.AuthService.setTokens(tokens.access, tokens.refresh);
                    ctrl.AuthService.setLoggedInFlag();
                    ctrl.$window.location.replace(
                        ctrl.$state.href(homescreenState),
                    );
                }
            })
            .catch(function () {
                if (!ctrl.destroyed) {
                    ctrl.error = "kioskLogin.BADGE_ERROR";
                    ctrl.processing = false;
                }
            });
    }

    pairDevice() {
        let ctrl = this;
        return ctrl.$state.go(kioskPairState, {}, { location: "replace" });
    }

    $onDestroy() {
        let ctrl = this;
        ctrl.destroyed = true;
        ctrl.scanning = false;
    }
}

export default {
    name: "kioskLogin",
    controller: KioskLoginController,
    template,
    bindings: { kioskId: "<" },
    translations: { en, es },
};
